namespace RioERP.Orders {
    export interface OrderGiftCardsForm {
        GiftCardId: Serenity.IntegerEditor;
        GiftCardCouponCode: Serenity.StringEditor;
        Amount: Serenity.DecimalEditor;
        BalanceAmount: Serenity.DecimalEditor;
    }

    export class OrderGiftCardsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderGiftCards';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderGiftCardsForm.init)  {
                OrderGiftCardsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(OrderGiftCardsForm, [
                    'GiftCardId', w0,
                    'GiftCardCouponCode', w1,
                    'Amount', w2,
                    'BalanceAmount', w2
                ]);
            }
        }
    }
}
